const CardType = {
  Mastercard: "master-card",
  Visa: "visa",
  Jcb: "jcb",
};

export default CardType;
